import { Size, Rect } from '../../../lib/imaging'
import { MainImagePhotoFrame } from '../types'

import { cloneDeep } from 'lodash'

export interface PhotoFrame {
  out: Rect
  in: Size
  restrict: Rect
}

export const nonePhotoFrame: PhotoFrame = {
  out: {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  restrict: {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  in: {
    width: 0,
    height: 0
  }
}

export const portraitPhotoFrame: PhotoFrame = {
  out: {
    x: 1731,
    y: 133,
    width: 387,
    height: 538
  },
  restrict: {
    x: 1731,
    y: 133,
    width: 387,
    // height: 620
    height: 538 + 80
  },
  in: {
    // width: 372,
    width: 387 - 8,
    // height: 524
    height: 538 - 8
  }
}

export const landscapePhotoFrame: PhotoFrame = {
  out: {
    x: 1584,
    y: 159,
    width: 680,
    height: 488
  },
  restrict: {
    x: 1584,
    y: 159,
    width: 680,
    // height: 600
    height: 488 + 80
  },
  in: {
    // width: 662,
    width: 680 - 8,
    // height: 470
    height: 488 - 8
  }
}

export const squarePhotoFrame: PhotoFrame = {
  out: {
    x: 1666,
    y: 145,
    width: 516,
    height: 516
  },
  restrict: {
    x: 1666,
    y: 145,
    width: 516,
    // height: 610
    height: 516 + 80
  },
  in: {
    // width: 500,
    width: 516 - 8,
    // height: 500
    height: 516 - 8
  }
}

export const getPhotoFrame = (
  mainImagePhotoFrame: MainImagePhotoFrame | null,
  mainImageSize: Size,
  mainImagePhotoY: number,
  mainImagePhotoScale: number
) => {
  let photoFrame = nonePhotoFrame
  if (mainImagePhotoFrame === MainImagePhotoFrame.Portrait) {
    photoFrame = portraitPhotoFrame
  } else if (mainImagePhotoFrame === MainImagePhotoFrame.Square) {
    photoFrame = squarePhotoFrame
  } else if (mainImagePhotoFrame === MainImagePhotoFrame.Landscape) {
    photoFrame = landscapePhotoFrame
  } else if (mainImagePhotoFrame === MainImagePhotoFrame.FrameLess) {
    console.log('mainImageSize', mainImageSize)
    const mainImageWidth = mainImageSize.width
    const mainImageHeight = mainImageSize.height

    const canvasWidth = 3840
    // const canvasHeight = 1080

    const maxHeight = 565

    let width = mainImageWidth
    let height = mainImageHeight

    // 元画像のアスペクト比を保持したまま、縦サイズをmaxHeightにリサイズする
    const scale = maxHeight / height
    width = width * scale
    height = height * scale

    width = width * mainImagePhotoScale
    height = height * mainImagePhotoScale
    // console.log('width', width, 'height', height)

    const x = (canvasWidth - width) / 2
    const y = 100 - mainImagePhotoY
    // console.log('x', x, 'y', y)

    const freeSizePhotoFrame: PhotoFrame = {
      out: {
        x: x,
        y: y,
        width: width,
        height: height
      },
      restrict: {
        x: x,
        y: y,
        width: width,
        height: height + 80
      },
      in: {
        width: width,
        height: height
      }
    }

    photoFrame = freeSizePhotoFrame
  }

  return cloneDeep(photoFrame)
}

export const getForeImagePath = (
  mainImagePhotoFrame: MainImagePhotoFrame | null
) => {
  const base = '/images/photo/'
  if (mainImagePhotoFrame === MainImagePhotoFrame.Portrait) {
    return base + 'portrait-front.png'
  } else if (mainImagePhotoFrame === MainImagePhotoFrame.Square) {
    return base + 'square-front.png'
  } else if (mainImagePhotoFrame === MainImagePhotoFrame.Landscape) {
    return base + 'landscape-front.png'
  } else if (mainImagePhotoFrame === MainImagePhotoFrame.FrameLess) {
    return base + 'kousi-front.png'
  }
  return null
}

export const getBackImagePath = (
  mainImagePhotoFrame: MainImagePhotoFrame | null
) => {
  const base = '/images/photo/'
  if (mainImagePhotoFrame === MainImagePhotoFrame.Portrait) {
    return base + 'portrait-back.png'
  } else if (mainImagePhotoFrame === MainImagePhotoFrame.Square) {
    return base + 'square-back.png'
  } else if (mainImagePhotoFrame === MainImagePhotoFrame.Landscape) {
    return base + 'landscape-back.png'
  } else if (mainImagePhotoFrame === MainImagePhotoFrame.FrameLess) {
    return null
  }
  return null
}
